export const NO_ACTIVE_CONTRACT = 'No active contract';

// Token refresh timing constants

/**
 * Buffer (seconds) before token expiry to trigger proactive refresh.
 *
 * Positive value passed to isValid(buffer) means check if token is valid
 * "buffer seconds in the future": currentTime + buffer < expiryTime
 * Example: Token expires at 14:00:00, buffer +100s = refresh at 13:58:20
 *
 * Prevents race conditions where network delays cause token to expire during API calls.
 *
 * Note: Previously was -100 (negative), but @openid/appauth isValid() interprets
 * negative buffers incorrectly, allowing expired tokens to be treated as valid.
 * Changed to +100 to fix the bug and align with library's expected semantics.
 */
export const TOKEN_REFRESH_BUFFER_SECONDS = 100;

/** Interval (ms) for proactive refresh. Used by useAuth(alwaysFresh = true). */
export const PROACTIVE_REFRESH_INTERVAL_MS = 60_000;

/** Expected token validity from IUM (reference only, actual value from server). */
export const TOKEN_VALIDITY_SECONDS = 3600; // 1 hour
